import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
  getMetadata,
} from "firebase/storage";
import { storage } from "./FirebaseSetup";
import { v4 as uuidv4 } from "uuid";


const fileUpload = (file, onProgress) => {
  if (!file) return;

  const ext = file.name.split('.').pop();
  const uniqueName = `${uuidv4()}.${ext}`;
  //const storageRef = ref(storage, `program_workout_attachments/${file.name}`);
  const corporate_identifier = localStorage.getItem("corporate_identifier") ?? "default";
  const storageRef = ref(storage, `${corporate_identifier}/program_workout_attachments/${uniqueName}`);
  const uploadTask = uploadBytesResumable(storageRef, file);

  return new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        onProgress(progress);
      },
      (error) => {
        console.error("File Upload Error ------>", error);
        reject(error);
      },
      async () => {
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve({ uploadTask, fileLink: downloadURL }); // ✅ return both
        } catch (err) {
          reject(err);
        }
      }
    );
  });
};

const fileUploadWithCancel = (file, onProgress) => {
  if (!file) return;

  const ext = file.name.split('.').pop();
  const uniqueName = `${uuidv4()}.${ext}`; 
  //const storageRef = ref(storage, `program_workout_attachments/${file.name}`);
  const corporate_identifier = localStorage.getItem("corporate_identifier") ?? "default";
  const storageRef = ref(storage, `${corporate_identifier}/program_workout_attachments/${uniqueName}`);
  const uploadTask = uploadBytesResumable(storageRef, file);

  // Start listening
  const urlPromise = new Promise((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        onProgress(progress);
      },
      (error) => {
        console.error("File Upload Error ------>", error);
        reject(error);
      },
      async () => {
        try {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          resolve(downloadURL);
        } catch (err) {
          reject(err);
        }
      }
    );
  });

  // ✅ return both immediately
  return { uploadTask, urlPromise };
};

const deleteFile = async (fileName) => {
  if (!fileName) return;

  const corporate_identifier = localStorage.getItem("corporate_identifier") ?? "default";
  const fileRef = ref(storage, `${corporate_identifier}/program_workout_attachments/${fileName}`);
  const fileRef2 = ref(storage, `program_workout_attachments/${fileName}`);

  try {
    await getMetadata(fileRef);

    await deleteObject(fileRef);
    console.log("File deleted successfully");
    return 1;
  } catch (error) {
      try {
      await getMetadata(fileRef2);

      await deleteObject(fileRef2);
      console.log("File deleted successfully");
      return 1;
    } catch (error2) {
      if (error2.code === "storage/object-not-found") {
        console.error("File does not exist:", fileName);
      } else {
        console.error("Error deleting file:", error2);
      }
      return error2;
    }
  }
};

export const FirebaseServices = {
  fileUpload,
  fileUploadWithCancel,
  deleteFile,
};
